import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import serverChoiceStore from './store';
import { SVGPureIcon } from '@/ui';
import { Dropdown } from 'antd';
import client from '@/store/client';
import { useRef } from 'react';
import appLogger from '@public/log/monitor';
import userStore from '@/store/user';
import slsLogger from '@public/log/sls';
import globalStore from '@/store/global';
import { message } from 'antd';

const ServerChoice = observer(props => {
  const store = serverChoiceStore;
  const $refContainer = useRef(null);
  const [enableSelect, setEnableSelect] = useState(true);

  useEffect(() => {
    store.chat_list = Object.assign([], props.serverList || []);
    store.select_list = props.serverList || [];
  }, [props.serverList]);

  useEffect(() => {
    store.loadList();
  }, []);

  const maxCount = globalStore.cloudConfig?.assistantMcpConfig?.max_server_count;

  const ListItem = ({ item, store }) => {
    return (
      <li
        key={item.server_id}
        className={[
          'rounded-8px relative pl-8px overflow-hidden',
        ]}
      >
        {
          !enableSelect && !store.select_list.includes(item.server_name) ?
            <div
              className='size-full bg-white bg-opacity-50 absolute left-0 top-0'
              onClick={() => {
                message.error("选中超出最大配置");
              }}
            ></div> : null
        }
        <div
          className="flex h-40px items-center cursor-pointer hover:bg-black hover:bg-opacity-3 rounded-8px "
          onClick={() => {
            store.setServer(item.server_name)
            if (store.select_list.length >= maxCount) {
              setEnableSelect(false)
            } else {
              setEnableSelect(true)
            }
          }}
        >
          <div
            className={`min-w-16px flex justify-center items-center size-16px mr-10px ml-8px rounded-3px border-1px border-black ${store.select_list.includes(item.server_name) ? 'bg-black' : 'border-opacity-20'}`}
          >
            {
              store.select_list.includes(item.server_name) ? (
                <SVGPureIcon
                  className="relative size-12px text-white"
                  name="check"
                />
              ) : null
            }
          </div>
          <img className='min-w-20px size-20px rounded-full mr-6px' src={item.icon} />
          <span className="text-14px text-black truncate">
            {item.display_name}
          </span>
        </div>
      </li>
    );
  };

  const dropList = () => {
    return (
      <div
        className="w-260px bg-white rounded-16px pt-14px pb-12px pr-4px flex flex-col items-center mt-6px"
        style={{
          border: '1px solid rgba(0,0,0,.1)',
          boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.12)',
        }}
      >
        <dl className="w-full mb-0">
          <dt className="flex justify-between items-center pb-13px ml-16px mr-12px border-bottom-1px border-black border-opacity-6">
            <div className="text-black font-bold text-14px leading-20px">
              选择MCP工具
            </div>
            {/* <div className="font-14px text-[#006aff] hover:text-[#005EE3] cursor-pointer font-medium flex items-center">
              <div
                onClick={() => {
                  client.openPage(
                    client.is360se ? 'https://browser.360.cn/ai/mcpsquare-se.html' : 'https://browser.360.cn/ai/mcpsquare.html'
                  );
                }}
              >
                添加工具
              </div>
              <SVGPureIcon
                className="text-[#006aff] hover:text-[#005EE3]"
                size={18}
                name="arrows_right4"
              />
            </div> */}
          </dt>
          <dd className="max-h-342px overflow-y-auto nw-scrollbar-thin mt-8px">
            {store.server_list?.length > 0 ? (
              <ul>
                {store.server_list.map(item => {
                  return (
                    <ListItem key={item.server_id} item={item} store={store}  />
                  );
                })}
              </ul>
            ) : null}
          </dd>
        </dl>
      </div>
    );
  };

  return (
    <Dropdown
      dropdownRender={() => dropList()}
      trigger="click"
      placement="bottomLeft"
      autoAdjustOverflow={props?.scene === 'home' ? false : true}
      open={store.showList}
      onOpenChange={
        open => {
          store.setShowList(open);
        }
      }
      getPopupContainer={
        () => $refContainer.current
      }
    >
      <div
        className={[
          'cursor-pointer select-none rounded-8px pl-[10px] pr-[12px] py-[6px] flex items-center',
          'border-1px border-solid border-[rgba(0,0,0,.1)] h-36px',
          store.select_list.length
            ? '!bg-[#DCEAFE] text-[#006AFF] border-[rgba(0,0,0,0)]'
            : 'bg-gray-nav hover:bg-gray-nav-hover',
        ]}
        ref={$refContainer}
      >
        <div className="relative size-20px rounded-6.5px overflow-hidden">
          <SVGPureIcon
            className={`relative size-20px rounded-6.5px overflow-hidden`}
            name="mcp_tool_default"
          />
        </div>
        <span className={`text-[14px] ml-6px mr-8px`}>工具</span>
        <SVGPureIcon
          className={[
            'w-[12px] h-[8px] transform transition duration-200',
            store.showList ? 'rotate-180' : '',
          ]}
          name="down"
        />
      </div>
    </Dropdown>
  );
});

export default ServerChoice;
